import React, { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import UpsLogo from '../../assets/svg/UpsLogo';
import styles from './footer.css';
import NavigationContext from '../../context/navigationContext';

const Footer = forwardRef(({ footerColor }, ref) => {
  const { footerLinks } = useContext(NavigationContext);

  const isInternalLink = to => {
    return /^\/(?!\/)/.test(to);
  };

  return (
    <footer
      ref={ref}
      className={`${styles.footer} site-footer`}
      style={footerColor ? { backgroundColor: footerColor } : {}}>
      <div className={styles.content}>
        <a
          href="https://upstatement.com"
          rel="noopener noreferrer"
          target="_blank"
          className={styles.logoLink}>
          <UpsLogo />
        </a>
        <ul className={styles.list}>
          {footerLinks &&
            footerLinks.map(item => (
              <li className={styles.item} key={item.linkText}>
                {isInternalLink(item.link) && (
                  <NavLink className={styles.link} to={item.link}>
                    {item.linkText}
                  </NavLink>
                )}
                {!isInternalLink(item.link) && (
                  <a
                    className={styles.link}
                    href={item.link}
                    rel="noopener noreferrer"
                    target="_blank">
                    {item.linkText}
                  </a>
                )}
              </li>
            ))}
        </ul>
        <a href="mailto:art.direction@upstatement.com" className={styles.link}>
          Contact Us
        </a>
      </div>
    </footer>
  );
});

Footer.propTypes = {
  footerColor: PropTypes.string,
};

export default Footer;
